import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import { queryClient } from '@/library/react-query';
import { displayError } from '@/utils/functions/displayError';

export type UserUpiType = {
  vpa: string;
  id: string;
};

const addUpi = (data: UserUpiType): Promise<any> => {
  return axios.post(`dg/customers/${data.id}/vpa-details`, { vpa: data.vpa });
};

export const useAddUpi = () => {
  const mutation = useMutation({
    // onMutate: async (data:UserUpiType) => {
    //   await queryClient.cancelQueries("addUpi");
    // },
    mutationFn: addUpi,
    onSuccess: () => {
      queryClient.invalidateQueries(['bankInfo']);
    },
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
